import React, { useState } from 'react'
import styled from '@emotion/styled'
import * as yup from 'yup'
import { Form, spacer, fontSize, fontWeight } from 'stylist'
import { NoPadContainer } from 'components/Container'
import { Bold } from 'components/Text'
import PlainLink from 'components/PlainLink'
import { redirectDone } from 'utils'
import { putSampleState } from 'utils/api'

const FormWrapper = styled(NoPadContainer)`
  margin: ${spacer(4)} 0;
  min-height: 130px;

  form {
    position: relative;
    width: 100%;

    label {
      ${fontSize('s')};
      ${fontWeight('regular')};
    }

    .bottom-row {
      position: absolute;
      bottom: 0;

      .links {
        align-items: center;

        .divider {
          margin: 0 ${spacer(2)};
        }
      }
    }
  }
`

function PurchaseForm({ sampleID, liveURL }) {
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState(null)

  const handleSubmit = () => {
    if (submitted) {
      return // Don't submit more than once
    }
    setSubmitted(true)

    putSampleState(sampleID, 'live', liveURL)
      .then(() => redirectDone())
      .catch(error => setError(error))
  }

  if (error) {
    throw new Error(error)
  }

  return (
    <FormWrapper>
      <Form
        initialValues={{ confirmation: false }}
        validationSchema={yup.object().shape({
          confirmation: yup.boolean().equals([true], 'You must agree')
        })}
        onSubmit={handleSubmit}
      >
        <Form.Input
          name="confirmation"
          type="checkbox"
          label="I agree to purchase this sample which will be invoiced by Forsta."
        />
        <NoPadContainer className="bottom-row">
          <NoPadContainer className="links">
            {false ? (
              <React.Fragment>
                {' '}
                {/* Remove ternary when content provided for links */}
                <PlainLink>
                  <Bold>How it works</Bold>
                </PlainLink>
                <span className="divider">|</span>
                <PlainLink>
                  <Bold>Terms & Conditions</Bold>
                </PlainLink>
              </React.Fragment>
            ) : null}
          </NoPadContainer>
          <Form.SubmitButton>Launch</Form.SubmitButton>
        </NoPadContainer>
      </Form>
    </FormWrapper>
  )
}

export default PurchaseForm



// WEBPACK FOOTER //
// ./src/routes/purchase/form.js